import React, { useState } from 'react';
import { ExternalChip } from '../../lib/types';
import { useToast } from '../../components/Toast/ToastContext';
import Modal, { ModalTitle, ModalSubtitle, ModalActions } from '../../components/Modal/Modal';
import ConfirmSummary from '../../components/ConfirmSummary/ConfirmSummary';
import { ToggleGroup } from '../../components/FormField/ToggleGroup';
import { PortalField } from '../../components/FormField/PortalField';
import Button from '../../components/Button/Button';

interface ReassignChipModalProps {
  open: boolean;
  onClose: () => void;
  chip: ExternalChip | null;
  onReassign: (chip: ExternalChip, keepOwner: boolean) => void;
}

export default function ReassignChipModal({ open, onClose, chip, onReassign }: ReassignChipModalProps) {
  const { showToast } = useToast();
  const [keepOwner, setKeepOwner] = useState('keep');

  if (!chip) return null;

  function handleConfirm() {
    onReassign(chip!, keepOwner === 'keep');
    showToast(`Chip ${chip!.id} reassigned to your organization`);
    setKeepOwner('keep');
    onClose();
  }

  function handleClose() {
    setKeepOwner('keep');
    onClose();
  }

  return (
    <Modal open={open} onClose={handleClose}>
      <ModalTitle>Reassign Chip</ModalTitle>
      <ModalSubtitle>This will transfer the chip from {chip.organization} to your organization.</ModalSubtitle>

      <ConfirmSummary
        sections={[
          {
            title: 'Chip',
            fields: [
              { label: 'Chip ID', value: chip.id },
              { label: 'Pet', value: chip.petName },
              { label: 'Current Organization', value: chip.organization },
            ],
          },
        ]}
      />

      <PortalField label="Owner Information" fullWidth>
        <ToggleGroup
          options={[
            { value: 'keep', label: 'Keep existing owner info' },
            { value: 'clear', label: 'Clear owner info' },
          ]}
          value={keepOwner}
          onChange={setKeepOwner}
        />
      </PortalField>

      <ModalActions>
        <Button variant="secondary" onClick={handleClose}>
          Cancel
        </Button>
        <Button variant="green" onClick={handleConfirm}>
          Reassign
        </Button>
      </ModalActions>
    </Modal>
  );
}
